import {isMobileSafari} from 'shared/utils/browser-utils';

export const PDF_CONTENT_TYPE = 'application/pdf';
export const PDF_DOWNLOAD_LINK_CLASS = 'overlay-pdf-download';

// Mobile Safari renders only the first page of an embedded PDF and offers no way to download it

export function fetchContentType(url: string): Promise<string> {
  return fetch(url, {method: 'HEAD'})
    .then(r => r.headers.get('Content-Type') ?? '')
    .catch(() => '');
}

export function isPdfContentType(contentType: string | null | undefined): boolean {
  return !!contentType && contentType.toLowerCase().includes(PDF_CONTENT_TYPE);
}

export function shouldShowPdfDownloadLink(contentType: string | null | undefined): boolean {
  return isPdfContentType(contentType) && isMobileSafari();
}

export function createPdfDownloadLink(url: string): HTMLAnchorElement {
  const link = document.createElement('a');
  link.classList.add(PDF_DOWNLOAD_LINK_CLASS);
  link.href = url;
  link.target = '_blank';
  link.rel = 'noopener noreferrer';
  link.setAttribute('download', '');
  link.setAttribute('aria-label', 'Download PDF');

  const icon = document.createElement('span');
  icon.classList.add(`${PDF_DOWNLOAD_LINK_CLASS}-icon`);
  link.appendChild(icon);

  const label = document.createElement('span');
  label.textContent = 'Download PDF';
  link.appendChild(label);

  link.addEventListener('click', e => e.stopPropagation());
  return link;
}

export function appendPdfDownloadLink(
  container: HTMLElement,
  url: string,
  contentType: string | null | undefined
): HTMLAnchorElement | null {
  if (!shouldShowPdfDownloadLink(contentType)) {
    return null;
  }
  const link = createPdfDownloadLink(url);
  container.appendChild(link);
  return link;
}
